export default __webpack_public_path__ + "static/media/login_enter_code_graphic.62ba70a7.svg";